import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';

interface PublicEvent {
  id: number;
  title: string;
  description: string;
  date: string;
  location?: string;

  /*
   * Nome del file del volantino.
   *
   * Percorso:
   * src/assets/events/
   */
  flyer?: string;

  /*
   * Numero WhatsApp del referente.
   *
   * Esempio:
   * contacts: '+39 345 591 3238'
   */
  contacts?: string;

  /*
   * Numero di posti ancora disponibili.
   *
   * Esempio:
   * avaiable_places: 18
   *
   * Il campo è facoltativo.
   * Se non presente, il riquadro
   * non viene visualizzato.
   *
   * Se vale 0, il riquadro compare
   * mostrando correttamente 0 posti.
   */
  avaiable_places?: number;
}

interface PublicNews {
  id: number;
  title: string;
  description: string;
  date: string;
  link?: string;
}

interface EventBooking {
  firstName: string;
  lastName: string;
  registeredPeople: number | null;
  unregisteredPeople: number | null;
  children: number | null;
}

@Component({
  selector: 'app-info-page',
  templateUrl: './info-page.component.html',
  styleUrls: ['./info-page.component.scss'],
})
export class InfoPageComponent implements OnInit, OnDestroy {

  public isEventsLoading = true;
  public isNewsLoading = true;

  private eventsLoadingTimer: ReturnType<typeof setTimeout> | null = null;
  private newsLoadingTimer: ReturnType<typeof setTimeout> | null = null;

  public ngOnInit(): void {
    // Gli elementi sono locali: lo spinner iniziale indica la preparazione della vista.
    this.eventsLoadingTimer = setTimeout(() => { this.isEventsLoading = false; this.eventsLoadingTimer = null; }, 300);
    this.newsLoadingTimer = setTimeout(() => { this.isNewsLoading = false; this.newsLoadingTimer = null; }, 300);
  }

  public ngOnDestroy(): void {
    if (this.eventsLoadingTimer !== null) clearTimeout(this.eventsLoadingTimer);
    if (this.newsLoadingTimer !== null) clearTimeout(this.newsLoadingTimer);
  }

  private changeEventPage(nextIndex: number): void {
    if (this.isEventsLoading || nextIndex === this.currentEventIndex) return;
    this.isEventsLoading = true;
    this.eventsLoadingTimer = setTimeout(() => {
      this.currentEventIndex = nextIndex;
      this.isEventsLoading = false;
      this.eventsLoadingTimer = null;
    }, 280);
  }

  private changeNewsPage(nextIndex: number): void {
    if (this.isNewsLoading || nextIndex === this.currentNewsIndex) return;
    this.isNewsLoading = true;
    this.newsLoadingTimer = setTimeout(() => {
      this.currentNewsIndex = nextIndex;
      this.isNewsLoading = false;
      this.newsLoadingTimer = null;
    }, 280);
  }

  /*
   * ============================================================
   * EVENTI
   * ============================================================
   *
   * Aggiungere gli eventi direttamente in questo array.
   *
   * Formato data: YYYY-MM-DD
   *
   * Gli eventi passati vengono nascosti automaticamente.
   * Gli eventi futuri vengono ordinati per data crescente.
   *
   * Per associare un volantino:
   * flyer: 'nome_file.JPG'
   *
   * Per associare un numero WhatsApp:
   * contacts: '+39 345 591 3238'
   *
   * Per indicare i posti disponibili:
   * avaiable_places: 18
   *
   * FORMATTAZIONE DESCRIZIONE:
   *
   * **testo** = grassetto
   * __testo__ = grassetto sottolineato
   */

  public readonly events: PublicEvent[] = [
    /*{
      id: 1,
      title: '',
      description: ``,
      date: '',
      location: '',
      flyer: '.JPG',
      contacts: '+39 345 591 3238',
      avaiable_places: 53,
    },*/
    {
      id: 1,
      title: 'Mercatini di Natale',
      description:
      `
        Durante il viaggio faremo una sosta per chi desidera fare colazione o prendere qualcosa da bere.

      In mattinata arriveremo ad Arco, dove avremo tempo libero per visitare i suoi bellissimi Mercatini di Natale, ai piedi dell’antico castello. Potremo passeggiare tra le casette in legno, curiosare tra oggetti artigianali e idee regalo e, perché no, assaggiare qualche specialità del posto, come salumi, formaggi, caldarroste, strauben e vin brûlé. Un’occasione per respirare l’atmosfera natalizia e fare qualche acquisto in vista delle feste!

      In tarda mattinata ci sposteremo a **Trento**, dove avremo il pranzo libero e tutto il pomeriggio a disposizione per visitare i famosi Mercatini di Natale.

      Tra le bancarelle di **Piazza Fiera e Piazza Cesare Battisti** troveremo decorazioni natalizie, dolci, prodotti tipici, oggetti artigianali, giocattoli in legno e tante idee regalo. Tra luci, musica e profumi delle specialità locali, potremo passeggiare tranquillamente per il centro storico e goderci tutta la magia del Natale.

      Verso le ore **18:00** ci ritroveremo per ripartire verso casa. L’arrivo è previsto in tarda serata.

      Durante il viaggio di ritorno sono previste alcune soste, con possibilità di fermarsi per una cena facoltativa.

      **Una bella giornata in compagnia, tra mercatini, shopping, specialità tipiche e tanta atmosfera natalizia!**
        __Partenze:__
        **Pistoia, ore 5:00:** Via dell’Annona, davanti al mercato ortofrutticolo
        **Agliana, ore 5:20:** Rotonda della Misericordia
        **Prato, ore 5:30:** McDonald’s, uscita Prato Est
        **(gli orari sono indicativi e saranno confermati entro 7 giorni dalla partenza)**

        __La quota comprende:__
        **Viaggio A/R pullman Gran Turismo**
        **Accompagnatrice**
        **Assicurazione**
        **Assistenza tecnica fornita da Maoriland Viaggi**

        __La quota NON comprende:__
        **Tutto cio non riportato nella "quota comprende"**
        **Pasti**
        **Ticket vari**

        __Quote:__
        **Iscritto Sindacale: 50€**
        **NON Iscritto Sindacale: 60€**
        **Bambino fino a 12 anni: GRATIS**

        **Acconto alla prenotazione 20€ a passeggero e saldo alla partenza.**

        **Partecipanti minimi alla gita 40 persone (al non raggiungimento verrà restituito l'acconto).**
        **Per info e prenotazioni 345 591 3238.**
       `,
      date: '2026-11-29',
      location: 'Arco e Trento',
      flyer: 'trento_novembre2026.JPG',
      contacts: '+39 345 591 3238',
      avaiable_places: 30,
    },
    {
      id: 2,
      title: 'Carnevale di Venezia',
      description:
      `
        Incontro con i partecipanti e partenza in pullman alla volta di Venezia, con una breve sosta lungo il percorso per chi desidera fare colazione o concedersi una pausa ristoro.

        Arrivati a Piazzale Tronchetto, ci trasferiamo con battello privato in Piazza San Marco, nel cuoredella città, orintia immergerci nell'atmosfera unica del famoso Carnevale di Venezia!

        **La giornata sarà libera**, così onguno ptrà godersi Venezia come preferisce: passeggiare tra le calli, ammirare le splendide maschere e i costumi d'epoca, assistere agli spettacoli e alle manifestazioni del Carnevale oppure smplicemente lasciarsi conquistare dalla bellezza della città. Il pranzo sarà libero.

        Il carnevale di Venezia è una festa ricca di storia e tradizione, famosa in tutto il mondo per le sue maschere, i suoi colori e la sua atmosfera speciale. Per un giorno, Venezia si trasforma in un grandepalcoscenico a cielo aperto, dove curiosi, visitatori e figuranti si mescolano creando uno spettacolo davvero suggestivo.

        Nel pomeriggio, ritrovo libero a Piazzale Tronchetto e partenza in pullman per il viaggio di ritorno.

        **Arrivo previsto in serata, con tanti bei ricordi da portare a casa!**

        __Partenze:__
        **Pistoia , ore 05:30:** Via Annona, davanti al mercato ortofrutticolo
        **Prato, ore 06:00:** McDonald's uscita di Prato Ovest
        **Firenze Nord, ore 06:20:**  Hotel "The Gate" entrata autostrada
        **(gli orari sono indicativi e saranno confermati entro 7 giorni dalla partenza)**

        __La quota comprende:__
        **Viaggio A/R pullman Gran Turismo**
        **Trasfermiento di sola andata verso Piazza San Marco**
        **Accompagnatrice**
        **Assicurazione**
        **Assistenza tecnica fornita da Maoriland Viaggi**

        __La quota NON comprende:__
        **Tutto cio non riportato nella "quota comprende"**
        **Pasti**
        **Ticket vari**

        __Quote:__
        **Iscritto Sindacale: 70€**
        **NON Iscritto Sindacale: 80€**
        **Bambino fino a 12 anni: 30€**

        **Acconto alla prenotazione 20€ a passeggero e saldo alla partenza.**

        **Partecipanti minimi alla gita 40 persone (al non raggiungimento verrà restituito l'acconto).**
        **Per info e prenotazioni 345 591 3238.**
      `,
      date: '2027-01-31',
      location: 'Venezia',
      flyer: 'venezia_gennaio2027.JPG',
      contacts: '+39 345 591 3238',
      avaiable_places: 47,
    },
    {
      id: 3,
      title: 'Musei Vaticani Roma',
      description: `
        Ritrovo dei partecipanti e partenza in pullman in direzione Roma, con breve sosta lungo il percorso per una pausa ristoro facoltativa.

        All'arrivo in Vaticano, visita guidata dei **Musei Vaticani**, con ingresso e prenotazione inclusi. Durante il percorso sarà possibile ammirare i celebri affreschi di Michelangelo nella Cappella Sistina, le straordinarie opere di Raffaello e numerosi capolavori dell'arte classica.

        Situati all'interno dello Stato del Vaticano, i Musei Vaticani rappresentato uno dei complessi museali più importanti al mondo. Le loro collezioni raccolgono opere d'arte di inestimabile valore, accumulate nel corso dei secoli dai Pontefici. Fondati da Papa Giulio II nel XVI secolo, custodiscono un patrimonio artistico e culturale di straordinaria rilevanza, esposto lungo un articolato percorso di sale e gallerie.
        **Pranzo Libero.**

        Nel pomeriggio, possibilità di proseguire con visite individuali nella zona del Vaticano, tra cui la **Basilica di San Pietro**, con la maestosa cupola progettata da Michelangelo e il magnifico colonnato del Bernini. Sarà inoltre possibile passeggiare nei dintorni di Castel Sant’Angelo e lungo il Lungotevere.
        Al termine delle visite, partenza in pullman per il viaggio di rientro. Arrivo previsto in serata.
        __Partenze:__
        **Pistoia , ore 05:30:** Via Annona, davanti al mercato ortofrutticolo
        **Prato, ore 06:00:** McDonald's uscita di Prato Ovest
        **Firenze Nord, ore 06:20:** Hotel "The Gate" entrata autostrada
        **(gli orari sono indicativi e saranno confermati entro 7 giorni dalla partenza)**

        __La quota comprende:__
        **Viaggio A/R pullman Gran Turismo**
        **Ingresso con visita guidata ai Musei Vaticani**
        **Accompagnatrice**
        **Assicurazione**
        **Assistenza tecnica fornita da Maoriland Viaggi**

        __La quota NON comprende:__
        **Tutto cio non riportato nella "quota comprende"**
        **Pasti**
        **Ticket vari**

        __Quote:__
        **Iscritto Sindacale: 90€**
        **NON Iscritto Sindacale: 100€**
        **Bambino fino a 7 anni: 30€**

        **Acconto alla prenotazione 40€ a passeggero e saldo alla partenza.**

        **Partecipanti minimi alla gita 40 persone (al non raggiungimento verrà restituito l'acconto).**
        **Per info e prenotazioni 345 591 3238.**
      `,
      date: '2027-05-08',
      location: 'Roma',
      flyer: 'roma_maggio2027.JPG',
      contacts: '+39 345 591 3238',
      avaiable_places: 53,
    },
    {
      id: 4,
      title: 'Santuario Madonna della Corona e Sirmone',
      description: `
        Ritrovo dei partecipanti e partenza in pullman in direzione del Santuario della Madonna della Corona. Durante il percorso è prevista una breve sosta per ristoro facoltativo.

        Arrivo al **Santuario della Madonna della Corona**, importante luogo di pellegrinaggio situato a circa 775 metri di altitudine, sulle pendici rocciose del Monte Baldo, in Veneto. Il santuario, caratterizzato dalla suggestiva chiesa incastonata nella parete rocciosa, si distingue per la sua particolare posizione e per il contesto paesaggistico di notevole interesse, con panorami sulla Valle dell’Adige.
        La visita potrà essere effettuata raggiungendo il santuario a piedi, attraverso il percorso pedonale della durata indicativa di circa 15 minuti, oppure usufruendo del servizio navetta a pagamento gestito da ATV, che collega il parcheggio degli autobus al santuario.
        Al termine della visita, trasferimento a **Sirmione**, rinomata località turistica situata sulla penisola del Lago di Garda. Pranzo libero presso i ristoranti e i locali della zona.
        Nel pomeriggio, escursione in battello sul Lago di Garda, con biglietti inclusi, durante la quale sarà possibile ammirare il paesaggio lacustre e le bellezze del territorio circostante.
        Al termine delle attività, ritrovo dei partecipanti presso il pullman e partenza per il viaggio di rientro. Arrivo previsto in tarda serata.
        __Partenze:__
        **Pistoia , ore 05:30:** Via Annona, davanti al mercato ortofrutticolo
        **Prato, ore 06:00:** McDonald's uscita di Prato Ovest
        **Firenze Nord, ore 06:20:** Hotel "The Gate" entrata autostrada
        **(gli orari sono indicativi e saranno confermati entro 7 giorni dalla partenza)**

        __La quota comprende:__
        **Viaggio A/R pullman Gran Turismo**
        **Giro di Sirmone in battello (25 minuti circa)**
        **Accompagnatrice**
        **Assicurazione**
        **Assistenza tecnica fornita da Maoriland Viaggi**

        __La quota NON comprende:__
        **Tutto cio non riportato nella "quota comprende"**
        **Pasti**
        **Ticket vari**

        __Quote:__
        **Iscritto Sindacale: 65€**
        **NON Iscritto Sindacale: 75€**
        **Bambino fino a 12 anni: 30€**

        **Acconto alla prenotazione 20€ a passeggero e saldo alla partenza.**

        **Partecipanti minimi alla gita 40 persone (al non raggiungimento verrà restituito l'acconto).**
        **Per info e prenotazioni 345 591 3238.**
      `,
      date: '2027-06-06',
      location: 'Lago di Garda',
      flyer: 'sirmone_giugno2027.JPG',
      contacts: '+39 345 591 3238',
      avaiable_places: 53,
    },
  ];

  /*
   * ============================================================
   * NEWS
   * ============================================================
   *
   * Aggiungere le notizie direttamente in questo array.
   *
   * Formato data: YYYY-MM-DD
   *
   * Il campo link è facoltativo.
   * Le news vengono ordinate dalla più recente alla più vecchia.
   */

  public readonly news: PublicNews[] = [
    /*{
      id: ,
      title: '',
      description: ' […]',
      date: '2026-11-',
      link: '',
    },*/
    {
      id: 7,
      title: 'Pistoia: doppia cerimonia per commemorare i caduti in guerra',
      description: 'Due momenti di raccoglimento e memoria per ricordare chi ha sacrificato la propria vita in nome della libertà e della pace. Pistoia ha celebrato la ricorrenza del 2 novembre con due cerimonie istituzionali, alla presenza delle autorità civili e militari. […]',
      date: '2026-11-02',
      link: 'https://tvl.it/notizie/cronaca/pistoia-doppia-cerimonia-per-commemorare-caduti-in-guerra/?fbclid=IwZnRzaAVVlYxleHRuA2FlbQIxMQBwZG9mBWZkaWQWURf4Y-WCxYIDPwph_29gJmCjrwoouHNydGMGYXBwX2lkCjY2Mjg1NjgzNzkAAR9D19sg5aQxagSyhw8a7i1JFwE1R8-b-90-yACnzC0Rhow9EcawriCGdxr61Q_aem_xvhe6VL2D7alYl80qHY41w&utm_id=97757_v0_s00_e0_tv2_a1demo0jgz8sk6',
    },
    {
      id: 8,
      title: 'Pistoia: arrestato per estorsione in flagranza di reato',
      description: 'Nei giorni scorsi… i Carabinieri del Nucleo Investigativo del Comando Provinciale di Pistoia hanno tratto in arresto in flagranza di reato un trentenne residente a Pistoia, gravemente indiziato del reato di estorsione. […]',
      date: '2026-11-03',
      link: 'https://tvl.it/notizie/cronaca/pistoia-arrestato-per-estorsione-in-flagranza-di-reato/?fbclid=IwZnRzaAVWpCpleHRuA2FlbQIxMQBwZG9mBWZkaWQWURgFH5npAb0Hiv-Wn3KaN5o36bXIIHNydGMGYXBwX2lkCjY2Mjg1NjgzNzkAAR9tnQbIPbJZttuaJsDE1Qmyt044upn0emv78UYxNOvK3u162HxY12sSNYROSA_aem_jy9y1Da7uZr9GgZBGK3p5g&utm_id=97757_v0_s00_e0_tv2_a1demo0jgz8sk6',
    },
    {
      id: 9,
      title: 'Detriti e argini erosi: timori in vista delle piogge',
      description: 'Antonio Barghini, pensionato pistoiese delle ferrovie, guarda con preoccupazione l’alveo del torrente Ombrone ora in secca. […]',
      date: '2026-11-03',
      link: 'https://tvl.it/notizie/cronaca/detriti-e-argini-erosi-timori-in-vista-delle-piogge/?fbclid=IwZnRzaAVW9KpleHRuA2FlbQIxMQBwZG9mBWZkaWQWURhTV-Zquak_qQIYinGgD7HZvXzEPHNydGMGYXBwX2lkCjY2Mjg1NjgzNzkAAR9qD7GCQ91_bX4TkD51182bNvCFeJzFZbajTpHxIrpmEaWSGw9xD2xcsN0iag_aem_iByzgYGhqdOQs-rA0t1lpg&utm_id=97757_v0_s00_e0_tv2_a1demo0jgz8sk6',
    },
    {
      id: 10,
      title: 'Montecatini Terme: grave incidente in stazione',
      description: 'Brutto episodio questa mattina alla stazione di Piazza Italia a Montecatini dove una ragazza è stata investita da un treno regionale. […]',
      date: '2026-11-04',
      link: 'https://tvl.it/notizie/cronaca/montecatini-terme-grave-incidente-in-stazione/?fbclid=IwZnRzaAVX_qpleHRuA2FlbQIxMQBwZG9mBWZkaWQWURmxVXqlknjR-_G2bH_ponqoqLhQ2XNydGMGYXBwX2lkCjY2Mjg1NjgzNzkAAR-oYA0oPpJjMYIgCuM-dU-MFUkc9Ohemlics-XBZCh4omM3CuWWD8jffphJyw_aem_1OACxOltYL7qouoYGfshGA&utm_id=97757_v0_s00_e0_tv2',
    },
    {
      id: 11,
      title: 'Pistoia: celebrazione del 4 novembre, omaggio ai caduti',
      description: 'Pistoia ha celebrato la Giornata dell’Unità Nazionale e delle Forze Armate con una cerimonia al Monumento ai Caduti in piazza San Francesco. […]',
      date: '2026-11-04',
      link: 'https://tvl.it/notizie/cronaca/pistoia-celebrazione-del-4-novembre-omaggio-ai-caduti/?fbclid=IwZnRzaAVYM11leHRuA2FlbQIxMQBwZG9mBWZkaWQWURkPN6MLAJ8tntI1CMgKgVfiXZsr23NydGMGYXBwX2lkCjY2Mjg1NjgzNzkAAR8JLZ027heObEfasChrNxGVhLiMqRCloaJQcpCO1wDekc0H1H8C_m8gKDQyYg_aem_ku9YUqofgSphwLndpSvSxQ&utm_id=97757_v0_s00_e0_tv2',
    },
  ];

  /*
   * ============================================================
   * NAVIGAZIONE EVENTI E NEWS
   * ============================================================
   */

  public currentEventIndex = 0;
  public currentNewsIndex = 0;

  public readonly newsPerPageDesktop = 2;
  public readonly newsPerPageMobile = 1;
  public isMobileNewsView = typeof window !== 'undefined' && window.innerWidth <= 767;

  @HostListener('window:resize')
  public onWindowResize(): void {
    if (typeof window === 'undefined') return;
    const mobile = window.innerWidth <= 767;
    if (mobile !== this.isMobileNewsView) {
      this.isMobileNewsView = mobile;
      const count = this.newsPerPage;
      this.currentNewsIndex = Math.floor(this.currentNewsIndex / count) * count;
      this.currentNewsIndex = Math.min(this.currentNewsIndex, Math.floor(Math.max(0, this.sortedNews.length - 1) / count) * count);
    }
  }

  public get newsPerPage(): number {
    return this.isMobileNewsView ? this.newsPerPageMobile : this.newsPerPageDesktop;
  }

  public get newsCounterLabel(): string {
    const total = this.sortedNews.length;
    if (!total) return '0/0';
    const first = this.currentNewsIndex + 1;
    const last = Math.min(this.currentNewsIndex + this.newsPerPage, total);
    return first === last ? `${first}/${total}` : `${first}-${last}/${total}`;
  }

  public get visibleNews(): PublicNews[] {
    return this.sortedNews.slice(this.currentNewsIndex, this.currentNewsIndex + this.newsPerPage);
  }

  public get canGoToPreviousNews(): boolean {
    return this.currentNewsIndex > 0;
  }

  public get canGoToNextNews(): boolean {
    return this.currentNewsIndex + this.newsPerPage < this.sortedNews.length;
  }

  public get currentEvent(): PublicEvent | null {
    return this.upcomingEvents[this.currentEventIndex] ?? null;
  }

  public get currentNews(): PublicNews | null {
    return this.sortedNews[this.currentNewsIndex] ?? null;
  }

  public previousEvent(): void {
    if (this.currentEventIndex > 0) {
      this.changeEventPage(this.currentEventIndex - 1);
    }
  }

  public nextEvent(): void {
    if (this.currentEventIndex < this.upcomingEvents.length - 1) {
      this.changeEventPage(this.currentEventIndex + 1);
    }
  }

  public previousNews(): void {
    if (this.canGoToPreviousNews) {
      this.changeNewsPage(Math.max(0, this.currentNewsIndex - this.newsPerPage));
    }
  }

  public nextNews(): void {
    if (this.canGoToNextNews) {
      this.changeNewsPage(this.currentNewsIndex + this.newsPerPage);
    }
  }

  public get upcomingEvents(): PublicEvent[] {
    const today = this.getTodayString();

    return [...this.events]
      .filter((event) => event.date >= today)
      .sort((a, b) => a.date.localeCompare(b.date));
  }

  /*
   * ============================================================
   * NEWS ORDINATE
   * ============================================================
   */

  public get sortedNews(): PublicNews[] {
    return [...this.news].sort((a, b) => b.id - a.id);
  }

  /*
   * ============================================================
   * DIALOG DETTAGLI EVENTO
   * ============================================================
   */

  public eventDialogVisible = false;

  public selectedEvent: PublicEvent | null = null;

  /**
   * Restituisce il percorso pubblico
   * del volantino associato all'evento.
   */
  public getEventFlyerUrl(fileName: string): string {
    return `assets/events/${fileName}`;
  }

  /**
   * Apre la dialog con le informazioni
   * dell'evento selezionato.
   */
  public openEventDialog(event: PublicEvent): void {
    this.selectedEvent = event;
    this.eventDialogVisible = true;
  }

  /**
   * Chiude la dialog.
   */
  public closeEventDialog(): void {
    this.eventDialogVisible = false;

    // Non azzerare l'evento mentre la prenotazione è aperta.
    if (!this.bookingDialogVisible) {
      this.selectedEvent = null;
    }
  }

  /*
   * ============================================================
   * FORMATTAZIONE DESCRIZIONE EVENTI
   * ============================================================
   *
   * **testo** = grassetto
   * __testo__ = grassetto e sottolineato
   *
   * Il testo originale viene convertito in caratteri HTML
   * sicuri prima di applicare la formattazione.
   */

  public formatEventDescription(
    description: string | null | undefined
  ): string {
    if (!description) {
      return '';
    }

    const escapedDescription = description
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

    return escapedDescription
    .replace(/__([^_\n]+)__/g, '<strong><u>$1</u></strong>')
    .replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>');
  }

  /*
   * ============================================================
   * PRENOTAZIONE EVENTO
   * ============================================================
   *
   * La prenotazione non viene salvata automaticamente.
   *
   * Alla conferma viene aperta una chat WhatsApp
   * con un messaggio precompilato.
   *
   * L'utente dovrà premere manualmente "Invia".
   */

  public bookingDialogVisible = false;

  public bookingEvent: PublicEvent | null = null;

  public booking: EventBooking = this.createEmptyBooking();

  /**
   * Crea un modulo di prenotazione vuoto.
   *
   * I valori null servono per distinguere
   * un campo non compilato dal numero 0.
   */
  private createEmptyBooking(): EventBooking {
    return {
      firstName: '',
      lastName: '',
      registeredPeople: null,
      unregisteredPeople: null,
      children: null,
    };
  }

  /**
   * Apre la dialog di prenotazione.
   */
  public openBookingDialog(event: PublicEvent): void {
    if (
      !event.contacts ||
      event.avaiable_places === 0
    ) {
      return;
    }

    this.bookingEvent = event;
    this.booking = this.createEmptyBooking();

    this.bookingDialogVisible = true;
  }

  /**
   * Chiude la dialog di prenotazione
   * e cancella i dati compilati.
   *
   * La dialog dei dettagli evento rimane aperta
   * se l'utente annulla la prenotazione.
   */
  public closeBookingDialog(): void {
    this.bookingDialogVisible = false;
    this.bookingEvent = null;
    this.booking = this.createEmptyBooking();
  }

  /**
   * Verifica che un numero sia un intero
   * maggiore o uguale a zero.
   */
  private isValidPeopleCount(
    value: number | null
  ): boolean {
    return (
      value !== null &&
      Number.isInteger(value) &&
      value >= 0
    );
  }

  /**
   * Numero totale dei partecipanti.
   */
  public get bookingTotalPeople(): number {
    return (
      (this.booking.registeredPeople ?? 0) +
      (this.booking.unregisteredPeople ?? 0) +
      (this.booking.children ?? 0)
    );
  }

  /**
   * Il pulsante Conferma è abilitato soltanto se:
   *
   * - Nome compilato
   * - Cognome compilato
   * - Tutti e tre i numeri compilati
   * - Numeri interi e non negativi
   * - Almeno un partecipante
   * - Partecipanti non superiori ai posti disponibili,
   *   quando il dato è configurato.
   */
  public get isBookingValid(): boolean {
    const event = this.bookingEvent;

    if (!event || !event.contacts) {
      return false;
    }

    const firstName = this.booking.firstName.trim();
    const lastName = this.booking.lastName.trim();

    if (!firstName || !lastName) {
      return false;
    }

    if (
      !this.isValidPeopleCount(this.booking.registeredPeople) ||
      !this.isValidPeopleCount(this.booking.unregisteredPeople) ||
      !this.isValidPeopleCount(this.booking.children)
    ) {
      return false;
    }

    if (this.bookingTotalPeople < 1) {
      return false;
    }

    if (
      event.avaiable_places !== undefined &&
      this.bookingTotalPeople > event.avaiable_places
    ) {
      return false;
    }

    return true;
  }

  /**
   * Costruisce il testo della prenotazione
   * da inserire automaticamente su WhatsApp.
   */
  private buildBookingMessage(event: PublicEvent): string {
    const eventDate = this.parseDate(event.date)
      .toLocaleDateString('it-IT', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      });

    const lines = [
      'Buongiorno, vorrei richiedere una prenotazione.',
      '',
      '*EVENTO:* ' + event.title,
      '*DATA:* ' + eventDate,
      '',
      '*DATI DELLA PRENOTAZIONE*',
      '',
      '*Nome:* ' + this.booking.firstName.trim(),
      '*Cognome:* ' + this.booking.lastName.trim(),
      '',
      '*Numero persone ISCRITTE:* ' +
        this.booking.registeredPeople,
      '*Numero persone NON ISCRITTE:* ' +
        this.booking.unregisteredPeople,
      '*Numero BAMBINI:* ' +
        this.booking.children,
      '',
      '*TOTALE PARTECIPANTI:* ' +
        this.bookingTotalPeople,
      '',
      'Resto in attesa di conferma della disponibilità.',
      'Grazie.',
    ];

    return lines.join('\n');
  }

  /**
   * Apre WhatsApp con il messaggio precompilato.
   *
   * IMPORTANTE:
   * Il messaggio NON viene inviato automaticamente.
   *
   * L'utente dovrà premere "Invia" nella chat.
   *
   * Dopo il click vengono chiuse entrambe
   * le dialog.
   */
  public confirmBooking(): void {
    if (!this.isBookingValid || !this.bookingEvent) {
      return;
    }

    const event = this.bookingEvent;

    if (!event.contacts) {
      return;
    }

    const message = this.buildBookingMessage(event);

    const cleanNumber = event.contacts.replace(/\D/g, '');

    const whatsappUrl =
      `https://wa.me/${cleanNumber}?text=${encodeURIComponent(message)}`;

    /*
     * Apertura immediata dopo il click:
     * questo riduce il rischio che il browser
     * blocchi WhatsApp come popup.
     */
    window.open(
      whatsappUrl,
      '_blank',
      'noopener,noreferrer'
    );

    /*
     * Chiusura di entrambe le dialog.
     */
    this.bookingDialogVisible = false;
    this.eventDialogVisible = false;

    this.bookingEvent = null;
    this.selectedEvent = null;

    this.booking = this.createEmptyBooking();
  }

  /*
   * ============================================================
   * WHATSAPP
   * ============================================================
   */

  /**
   * Genera il collegamento WhatsApp.
   *
   * Esempio:
   *
   * Numero configurato:
   * +39 345 591 3238
   *
   * URL generato:
   * https://wa.me/393455913238
   */
  public getWhatsAppUrl(phoneNumber: string): string {
    const cleanNumber = phoneNumber.replace(/\D/g, '');

    return `https://wa.me/${cleanNumber}`;
  }

  /*
   * ============================================================
   * TRACK BY
   * ============================================================
   */

  public trackByEvent(
    index: number,
    event: PublicEvent
  ): number {
    return event.id;
  }

  public trackByNews(
    index: number,
    news: PublicNews
  ): number {
    return news.id;
  }

  /*
   * ============================================================
   * GESTIONE DATE
   * ============================================================
   *
   * Interpreta YYYY-MM-DD come data locale,
   * evitando problemi di conversione UTC.
   */

  public parseDate(value: string): Date {
    const [year, month, day] = value
      .split('-')
      .map(Number);

    return new Date(year, month - 1, day);
  }

  private getTodayString(): string {
    const today = new Date();

    const year = today.getFullYear();

    const month = String(
      today.getMonth() + 1
    ).padStart(2, '0');

    const day = String(
      today.getDate()
    ).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }
}